import { render, staticRenderFns } from "./VideoListPage.vue?vue&type=template&id=663a1fcc&"
import script from "./VideoListPage.vue?vue&type=script&lang=ts&"
export * from "./VideoListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports